<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:flex-1 tw:px-[15px]" style="width: 300px;">

        <div #progress class="progress progress-circle tw:mx-auto">
            <span class="progress-left">
                <span class="progress-bar primary-border-colour"></span>
            </span>
            <span class="progress-right">
                <span class="progress-bar primary-border-colour"></span>
            </span>
            <div class="progress-value tw:w-full tw:h-full tw:rounded-full">
                <div class="tw:flex tw:flex-wrap tw:h-full">
                    <div class="tw:w-full tw:px-[15px] tw:flex tw:justify-center tw:items-end">
                        <label class="h2 tw:font-bold custom-header-text tw:font-[bolder]">{{ data.percentage }}%</label>
                    </div>
                    <div class="tw:w-full tw:px-[15px] tw:flex tw:justify-center tw:items-start">
                        <label class="gauge-sub-text">{{ data.subText }}</label>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>